export * from "ce/pages/AppIDE/layout/routers/utils/getJSEntityItemUrl";

import { getJSEntityItemUrl as CE_getJSEntityItemUrl } from "ce/pages/AppIDE/layout/routers/utils/getJSEntityItemUrl";
import type { EntityItem } from "ee/IDE/Interfaces/EntityItem";
import { moduleInstanceEditorURL } from "ee/RouteBuilder";
import { MODULE_TYPE } from "ee/constants/ModuleConstants";

export const getJSEntityItemUrl = (
  item: EntityItem,
  basePageId: string,
): string => {
  if (item.isModuleInstance) {
    return moduleInstanceEditorURL({
      basePageId,
      moduleType: MODULE_TYPE.JS,
      moduleInstanceId: item.key,
    });
  }

  return CE_getJSEntityItemUrl(item, basePageId);
};
